
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import CommonDialogComponent from './components/dialog/MapDialogComponent';
import CommonDrawerComponent from './components/drawer/MapDrawerComponent';
import Snackbar from './components/Snackbar';
import CommonMenuDialog from './menu';
import ReduxProvider from './providers/ReduxProvider';
import AppRoute from './routes/AppRoute';
import { ErrorWrapper } from './providers/ErrorBoundary';


const App = () => {
    console.log("App")
    return (
        <ReduxProvider>
            <Router>
                <ErrorWrapper>
                    <Routes>
                        <Route path='*' element={<AppRoute />} />
                    </Routes>
                    <CommonDrawerComponent />
                    <CommonDialogComponent />
                    <CommonMenuDialog />
                </ErrorWrapper>
            </Router>
            <Snackbar />
        </ReduxProvider>
    )
}

export default App;